var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jp-common-layout page" }, [
    _c("div", { staticClass: "jp-common-layout-left" }, [
      _c(
        "div",
        { staticClass: "jp-common-title" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入关键字进行过滤", size: "small" },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-button", {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                      circle: "",
                    },
                    on: { click: _vm.addTreeNode },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "jp-common-el-tree-scrollbar el-scrollbar" }, [
        _c("div", { staticClass: "el-scrollbar__wrap" }, [
          _c(
            "div",
            { staticClass: "el-scrollbar__view" },
            [
              _c("el-tree", {
                ref: "docCategoryTree",
                staticClass: "filter-tree",
                attrs: {
                  data: _vm.docCategoryTreeData,
                  props: {
                    value: "id", // ID字段名
                    label: "name", // 显示名称
                    children: "children", // 子级字段名
                  },
                  "default-expand-all": "",
                  "filter-node-method": _vm.filterNode,
                  "expand-on-click-node": false,
                },
                on: { "node-click": _vm.handleNodeClick },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c("span", { staticClass: "custom-tree-node" }, [
                        _c("span", [_vm._v(_vm._s(node.label))]),
                        _c(
                          "span",
                          [
                            _c("el-button", {
                              staticClass: "tree-item-button",
                              attrs: { type: "text", icon: "el-icon-plus" },
                              on: {
                                click: function () {
                                  return _vm.addChildTreeNode(data)
                                },
                              },
                            }),
                            _c("el-button", {
                              staticClass: "tree-item-button",
                              attrs: {
                                type: "text",
                                icon: "el-icon-edit-outline",
                              },
                              on: {
                                click: function () {
                                  return _vm.editTreeNode(data)
                                },
                              },
                            }),
                            _c("el-button", {
                              staticClass: "tree-item-button",
                              attrs: { type: "text", icon: "el-icon-delete" },
                              on: {
                                click: function () {
                                  return _vm.delTreeNode(data)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "jp-common-layout-center jp-flex-main" },
      [
        _c(
          "el-form",
          {
            ref: "searchForm",
            staticClass: "query-form",
            attrs: { inline: true, size: "small", model: _vm.searchForm },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.refreshList()
              },
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { prop: "docCategoryDTO.id" } },
              [
                _c("SelectTree", {
                  ref: "category",
                  attrs: {
                    props: {
                      value: "id", // ID字段名
                      label: "name", // 显示名称
                      children: "children", // 子级字段名
                    },
                    size: "small",
                    url: "/wps/docCategory/treeData",
                    value: _vm.searchForm.docCategoryDTO.id,
                    clearable: true,
                    accordion: true,
                  },
                  on: {
                    getValue: function (value) {
                      _vm.searchForm.docCategoryDTO.id = value
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.refreshList()
                      },
                    },
                  },
                  [_vm._v("查询")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.resetSearch()
                      },
                    },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bg-white top" },
          [
            _c("vxe-toolbar", {
              attrs: {
                refresh: { query: _vm.refreshList },
                export: "",
                print: "",
                custom: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "buttons",
                  fn: function () {
                    return [
                      _c(
                        "el-dropdown",
                        {
                          attrs: { trigger: "click" },
                          on: { command: _vm.createFile },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "e-b",
                              attrs: {
                                size: "small",
                                type: "primary",
                                icon: "el-icon-plus",
                              },
                            },
                            [_vm._v("新建")]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "w" } },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icon",
                                      attrs: { "aria-hidden": "true" },
                                    },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": "#icon-word1" },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v("文字文档")]
                                  ),
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "s" } },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icon",
                                      attrs: { "aria-hidden": "true" },
                                    },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": "#icon-excel1" },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v("表格文档")]
                                  ),
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "p" } },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icon",
                                      attrs: { "aria-hidden": "true" },
                                    },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": "#icon-ppt4" },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v("演示文档")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.hasPermission("wps:docTemplate:add")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                plain: "",
                                icon: "el-icon-upload",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.add()
                                },
                              },
                            },
                            [_vm._v("上传")]
                          )
                        : _vm._e(),
                      _vm.hasPermission("wps:docTemplate:edit")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "warning",
                                size: "small",
                                icon: "el-icon-edit-outline",
                                disabled:
                                  _vm.$refs.docTemplateTable &&
                                  _vm.$refs.docTemplateTable.getCheckboxRecords()
                                    .length !== 1,
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.edit()
                                },
                              },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.hasPermission("wps:docTemplate:del")
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                size: "small",
                                icon: "el-icon-delete",
                                disabled:
                                  _vm.$refs.docTemplateTable &&
                                  _vm.$refs.docTemplateTable.getCheckboxRecords()
                                    .length === 0,
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.del()
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c(
              "div",
              { staticStyle: { height: "calc(100% - 80px)" } },
              [
                _c(
                  "vxe-table",
                  {
                    ref: "docTemplateTable",
                    attrs: {
                      border: "inner",
                      "auto-resize": "",
                      resizable: "",
                      height: "auto",
                      loading: _vm.loading,
                      size: "small",
                      "show-header-overflow": "",
                      "show-overflow": "",
                      "highlight-hover-row": "",
                      "menu-config": {},
                      "print-config": {},
                      "import-config": {},
                      "export-config": {},
                      "sort-config": { remote: true },
                      data: _vm.dataList,
                      "checkbox-config": {},
                    },
                    on: { "sort-change": _vm.sortChangeHandle },
                  },
                  [
                    _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                    _c("vxe-column", {
                      attrs: { type: "checkbox", width: "40px" },
                    }),
                    _c("vxe-column", {
                      attrs: { title: "名称", field: "name", sortable: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.hasPermission("wps:docTemplate:edit")
                                ? _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        type: "primary",
                                        underline: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(scope.row.name) + " ")]
                                  )
                                : _vm.hasPermission("wps:docTemplate:view")
                                ? _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        type: "primary",
                                        underline: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.view(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(scope.row.name) + " ")]
                                  )
                                : _c("span", [_vm._v(_vm._s(scope.row.name))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("vxe-column", {
                      attrs: { title: "文件", field: "path", sortable: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return scope.row.path
                                ? [
                                    _vm.hasPermission("wps:docTemplate:edit")
                                      ? _c(
                                          "el-link",
                                          {
                                            attrs: {
                                              type: "primary",
                                              underline: false,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.design(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  decodeURIComponent(
                                                    scope.row.path.substring(
                                                      scope.row.path.lastIndexOf(
                                                        "&name="
                                                      ) + 6
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : undefined
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "类型",
                        field: "docCategoryDTO.name",
                        sortable: "",
                      },
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "备注信息",
                        field: "remarks",
                        sortable: "",
                      },
                    }),
                    _c("vxe-column", {
                      attrs: {
                        title: "操作",
                        width: "270px",
                        fixed: "right",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.hasPermission("wps:docTemplate:view")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-download",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.download(scope.row.path)
                                        },
                                      },
                                    },
                                    [_vm._v(" 下载 ")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("wps:docTemplate:edit")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-edit",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v(" 修改 ")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("wps:docTemplate:del")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-delete",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.del(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v(" 删除 ")]
                                  )
                                : _vm._e(),
                              _vm.hasPermission("wps:docTemplate:edit")
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-edit",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.design(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 编辑内容 ")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c("vxe-pager", {
                  attrs: {
                    background: "",
                    size: "small",
                    "current-page": _vm.tablePage.currentPage,
                    "page-size": _vm.tablePage.pageSize,
                    total: _vm.tablePage.total,
                    "page-sizes": [
                      10,
                      20,
                      100,
                      1000,
                      { label: "全量数据", value: 1000000 },
                    ],
                    layouts: [
                      "PrevPage",
                      "JumpNumber",
                      "NextPage",
                      "FullJump",
                      "Sizes",
                      "Total",
                    ],
                  },
                  on: { "page-change": _vm.currentChangeHandle },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("DocTemplateForm", {
          ref: "docTemplateForm",
          on: { refreshDataList: _vm.refreshList },
        }),
        _c("DocCategoryForm", {
          ref: "docCategoryForm",
          on: { refreshTree: _vm.refreshTree },
        }),
        _c(
          "el-dialog",
          {
            directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
            staticClass: "word",
            staticStyle: { padding: "0px" },
            attrs: {
              title: "编辑文档",
              "close-on-click-modal": true,
              fullscreen: "",
              visible: _vm.visible,
            },
            on: {
              "update:visible": function ($event) {
                _vm.visible = $event
              },
            },
          },
          [
            _vm.visible
              ? _c("iframe", {
                  attrs: {
                    src: _vm.wpsUrl,
                    frameborder: "0",
                    scrolling: "auto",
                    height: "1000px",
                    width: "100%",
                  },
                })
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }